<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                    <div class="card-header card-header-info">
                        <h4 class="card-title ">Tambah Tarif</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="bmd-label-floating">Nama</label>
                                    <p class="bmd-label-floating mb-0" v-text="data.params.nama"></p>
                                </div>
                                <div class="form-group">
                                    <label class="bmd-label-floating">Telepon</label>
                                    <p class="bmd-label-floating mb-0" v-text="data.params.wa"></p>
                                </div>
                                <div class="form-group">
                                    <label class="bmd-label-floating">Teks</label>
                                    <div class="bmd-label-floating mb-0" v-html="teks.br(data.params.text)"></div>
                                </div>
                                <div class="form-group">
                                    <label class="bmd-label-floating">Jam</label>
                                    <p class="bmd-label-floating mb-0">{{data.params.jam}} - {{tglIndo(data.params.tanggal)}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
	const data = reactive({
        params: ''
    })

	const tambah = {
      	data: reactive({
            via: "Pilih Via",
            id: null,
            ip: '',
            username: '',
            password: '',
            cpassword: '',
            nama: ''
      	}),
		submit() {
            /*
            var datax = this.data;

			var datac = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
                id: datax.id,
                ip: datax.ip,
                nama: datax.nama,
                username: datax.username,
                password: datax.cpassword,
                via: datax.via
        	};

            data.alert = false;
				
			var apiUrl = inter.MiktorikSimpan();
			myGlobal.call(datac,apiUrl).then(x => {
				if (x.status == true) {
                    location.href="#/mikrotik"
				} else {
					//alert(x.pesan);
				}
			})
            */
		}
    }
    const teks = {
        br(teks) {
            return teks.replace(/\n/g, '<br />')
        }
    }
    return {
      data,
      teks
    }

  },
  mounted () {

    var param = this.$route.params;
    this.data.params = param;

    console.log(JSON.stringify(this.data.params));
  }
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/laporan/rincian.vue